import Marquee from "react-fast-marquee";
import { PARTNERS } from "@/lib/site";

export const TrustMarquee = () => {
  return (
    <section data-testid="trust-bar" className="py-12 bg-white border-y border-black/5">
      <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-ink/40 mb-8">
        Trusted by Growing Businesses Across Delhi NCR
      </p>
      <Marquee gradient gradientColor="#ffffff" gradientWidth={80} speed={40} pauseOnHover>
        {PARTNERS.map((p) => (
          <div key={p} className="mx-8 flex items-center gap-2 text-navy/60 hover:text-navy transition-colors">
            <span className="w-2 h-2 rounded-full bg-brand/40" />
            <span className="font-display font-bold text-lg whitespace-nowrap">{p}</span>
          </div>
        ))}
      </Marquee>
      <p className="text-center text-[11px] text-ink/30 mt-6">Partner Banks &amp; NBFCs · Logos shown as reference partners</p>
    </section>
  );
};
